import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {

    static values = {
        reorderUrl: String,
    }

    connect() {
        console.log("Connected accounts_sort_controller")
        this.makeSortable(this.element)
    }

    makeSortable(container) {
        Sortable.create(container, {
            group: "accounts",
            handle: ".handle",
            animation: 150,
            fallbackOnBody: true,

            onEnd: (event) => {
                const item = event.item
                const parent = item.parentElement.closest("li")
                console.log(this.reorderUrlValue)
                const url = this.reorderUrlValue.replace(/RECORD_ID/g, item.dataset.id)
                console.log(url)
                fetch(url, {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-Token": document.querySelector("[name=csrf-token]").content
                    },
                    body: JSON.stringify({
                        parent_id: parent?.dataset.id || null,
                        position: event.newIndex
                    })
                })
            }
        })

        container.querySelectorAll(":scope > li > ul")
            .forEach(child => this.makeSortable(child))
    }
}
